import axios from 'axios';
import API from '../config/API';

// Refunds on a completed sale: thin client for /api/v2/refunds
// (beu-node-v2 docs/refunds.md, "API"). Every refund call in the app goes
// through here.
//
// Seller, permission and site are resolved by the server from the booking and
// the access token. Never send a salonId, a seller or an amount owner.
//
// Same envelope handling as permissions.service: v2 reports refusals as
// HTTP 200 { statusCode: 0, error }, so those reject with the server's own
// words on err.message (shown verbatim by the refund panel).

function headers() {
    return { 'Content-Type': 'application/json', accessToken: localStorage.getItem('accessToken') || '' };
}

const url = (path = '') => API.REFUNDS + path;

// The server's refusal envelope: { statusCode: 0, error: { errorCode,
// responseMessage, errors: { code, seller, canRequest, ... } } }. The refund
// code ('seller_only', 'no_permission', 'over_refund', ...) and its details
// ride in error.errors; they come out as err.code / err.detail.
function refusal(payload) {
    const e = payload.error;
    const msg = (e && (e.responseMessage || e.message)) || 'Request failed';
    const err = new Error(msg);
    err.response = { data: { ...payload, message: msg } };
    const extra = (e && e.errors && typeof e.errors === 'object') ? e.errors : null;
    err.code = (extra && extra.code) || undefined;
    err.detail = extra || undefined;
    err.fromServer = true;
    return err;
}

const data = (p) => p.then((r) => {
    const payload = r && r.data;
    if (!payload) return payload;
    if (payload.statusCode === 0 && payload.error) throw refusal(payload);
    if (payload.responseData !== undefined) return payload.responseData;
    if (payload.data !== undefined) return payload.data;
    return payload;
}, (e) => {
    const payload = e && e.response && e.response.data;
    if (payload && payload.error) throw refusal(payload);
    throw e;
});

export const refundService = {
    /** POST /preview { bookingId, lines?, amount?, methodSplit? } → what would happen, plus allowed/reason. */
    preview: (body) => data(axios.post(url('/preview'), body, { headers: headers() })),
    /** POST / { ...preview body, reason, note, restock, idempotencyKey } → { refund, refundStatus, refundedTotal }. */
    create: (body) => data(axios.post(url(''), body, { headers: headers() })),
    /** POST /request { bookingId, lines?, amount?, note } → asks the self-employed seller to refund. */
    request: (body) => data(axios.post(url('/request'), body, { headers: headers() })),
    /** GET /?bookingId= → the refunds on a sale. */
    list: (bookingId) => data(axios.get(url(''), { headers: headers(), params: { bookingId } })),
};

export default refundService;
